export default __webpack_public_path__ + "static/media/verify-email-check.6de0e60c.svg";